import { render, staticRenderFns } from "./freightList.vue?vue&type=template&id=d8c01278&scoped=true"
import script from "./freightList.vue?vue&type=script&lang=js"
export * from "./freightList.vue?vue&type=script&lang=js"
import style0 from "./freightList.vue?vue&type=style&index=0&id=d8c01278&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c01278",
  null
  
)

export default component.exports